import { TypeSchema } from "@smallstack/typesystem";
import { AllWidgetTags, WidgetRegistryEntry } from "@smallstack/widget-core";

export const AnonymizedStatsWidget: WidgetRegistryEntry = {
  name: "AnonymizedStats",
  configuration: {
    dataSchema: async () => {
      return {
        type: "object",
        properties: {
          dataType: {
            type: "string",
            "x-schema-form": {
              widget: "types"
            }
          } as TypeSchema,
          quartersCount: {
            type: "number",
            default: 8
          }
        }
      };
    },
    icon: "anonymous-mask",
    tags: AllWidgetTags,
    templateName: "Anonymisierungsstatistik",
    templateDescription: "Zeigt den aktuellen Status der Anonymisierung"
  },
  component: () => import("./anonymized-stats-widget.component").then((m) => m.AnonymizedStatsWidgetComponent)
};
